import React from 'react';
import { Outlet } from 'react-router';
import { Search } from '@mui/icons-material';
import { Container, InputAdornment, Stack, TextField, Typography } from '@mui/material';
import { HelpTopArticlesContainer } from '../../containers/help/HelpTopArticlesContainer';
import { useHelpCenterNavigation } from '../../hooks/help/useHelpCenterNavigation';
import { useTranslation } from 'react-i18next';

export const HelpPage = () => {
    return <Outlet />;
}

/** The initial page to show in the index of the help center */
export const HelpInitPage = () => {
    const { t } = useTranslation();
    const { navigateToAllTopics, navigateToArticle } = useHelpCenterNavigation();

    return (
        <Container sx={{ p: 2 }}>
            <Stack direction={'column'}
                justifyContent={'center'}
                alignItems={'center'}>
                <Typography variant='h1'>{t('help.page.header')}</Typography>
                <TextField variant='outlined'
                    label={t('help.search.inputLabel')}
                    placeholder={t('help.search.inputPlaceholder')}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <Search />
                            </InputAdornment>
                        ),
                    }} />
                <HelpTopArticlesContainer
                    onShowTopicsClick={navigateToAllTopics}
                    onArticleClick={navigateToArticle}
                />
            </Stack>
        </Container>
    )
}